export const vi = {
  shared_components: {
    common: {
      back: "Quay lại",
      confirm_cancel: "Bạn có chắc chắn muốn hủy",
      current_executor: "Người thực hiện hiện tại: ",
      filter: "Lọc điều kiện",
      inspector: "Người kiểm tra",
      load_more: "Kéo lên để tải nhiều hơn",
      no: "Không",
      organization_structure: "Cơ cấu tổ chức",
      please_enter: "Vui lòng nhập",
      please_select: "Vui lòng chọn",
      reject: "Từ chối",
      required_mark: " *",
      responsible_person: "Người phụ trách",
      status: "Trạng thái",
      submit_date_end: "Thời gian nộp (đến)",
      submit_date_start: "Thời gian nộp (từ)",
      yes: "Có",
      cancel: "Hủy bỏ",
      confirm: "Xác nhận",
      no_data: "Tạm không có dữ liệu",
      delete: "Xóa",
      save: "Lưu",
      submit: "Nộp",
      map_point: "Chữ ký biểu tượng phẳng",
      view_floor_plan: "Xem bản đồ mặt bằng",
      can_multi_select: "Có thể chọn nhiều",
      choose_take_photo_msg: "Chụp ảnh",
      project_cost_center_code: "Đơn vị phụ trách",
      project_name: "Cơ cấu tổ chức",
      choose: "Chọn",
      get_data_failed: "Lấy dữ liệu thất bại",
      go_back_key_img: "Quay lại",
      please_select_last_finding_category: "Vui lòng chọn danh mục sai lệch/phát hiện ở cấp thấp nhất.",
      floor_plan: "Bản vẽ mặt bằng"
    },
    add_inspection_object: {
      inspection_obj_add: "Thêm đối tượng kiểm tra ",
      inspection_obj_input: "Vui lòng nhập đối tượng kiểm tra",
      inspect_object_key: "Đối tượng kiểm tra",
      add_must: "Vui lòng thêm ít nhất một đối tượng kiểm tra",
      other: "Khác"
    },
    corp_select: {
      please_select_last_location_for_inspection: "Vui lòng chọn địa điểm kiểm tra thấp nhất"
    },
    filter_modals: {
      capa_code: "Mã CAPA",
      capa_exec_date: "Ngày kiểm tra/tiếp nhận",
      capa_final_verifier: "Người xác minh cuối cùng",
      capa_finding_desc: "Mô tả phát hiện",
      capa_finding_evidence: "Bằng chứng phát hiện",
      capa_finding_no: "Số phát hiện",
      capa_main_process: "Quy trình chính",
      capa_person_in_charge: "Người phụ trách",
      capa_source: "Nguồn CAPA",
      capa_subject_title: "Tiêu đề CAPA",
      capa_sub_process: "Quy trình phụ",
      completion_date: "Ngày hoàn công",
      corrective_finished: "Cải thiện được hoàn tất hay chưa?",
      data_scope: "Phạm vi dữ liệu",
      ehsq_number: "ID đánh giá",
      end_time: "Ngày kết thúc",
      end_time_not_lg_start_time: "Thời gian kết thúc không được nhỏ hơn thời gian bắt đầu",
      evaluation_method: "Phương pháp đánh giá",
      following_field: "Các trường sau sẽ được tạo sau khi biểu mẫu nhiệm vụ được lưu",
      from: "(Từ)",
      full_name: "Họ tên",
      hazard_type: "Loại tai nạn",
      help_center_doc_name: "Tên tài liệu",
      immediate_check_category: "Phân loại kiểm tra",
      incident_informant: "Người thông báo",
      inspection_level: "phân cấp kiểm tra",
      job_name: "Tên công việc",
      locations: "Địa điểm",
      poba: "Vị trí chấn thương",
      project_id: "ID dự án",
      project_name: "Tên dự án",
      rate: "Đánh giá",
      reporting_department: "Bộ phận báo cáo",
      responsibility_zone: "Khu vực Trách nhiệm",
      audit_reviewer: "Người phê duyệt",
      start_time: "Ngày bắt đầu",
      start_time_not_lg_end_time: "Thời gian bắt đầu không được lớn hơn thời gian kết thúc",
      supplier_id: "ID nhà thầu",
      target_finished: "Mục tiêu có được hoàn thành hay không",
      task_code: "Mã số nhiệm vụ",
      to: "(Đến)",
      unsafe_behavior: "Hành vi không an toàn",
      unsafe_condition: "Tình trạng không an toàn",
      violation_item: "Danh mục phát hiện",
      work_id_id: "ID thao tác",
      work_name: "Tên thao tác",
      work_related: "Liên quan đến công việc",
      id_number: "Số thẻ căn cước",
      incident_involved_person: "Các bên tham gia sự cố",
      incident_notifier_pro: "Giám đốc dự án",
      incident_reporting: "Báo cáo sự cố",
      inspection_finding_category: "Phân loại phát hiện",
      inspection_form: "Bảng kiểm tra",
      no: "Không",
      project_cost_center: "Cơ cấu tổ chức",
      project_name_bbs: "Cơ cấu tổ chức",
      reviewer: "Người đánh giá",
      service_type: "Loại hình dịch vụ",
      submit_person: "Người báo cáo",
      verification_person: "Người thử nghiệm",
      yes: "Có",
      audit_type_display_key: "Loại kiểm tra",
      business_line: "Ngành nghề kinh doanh",
      cancel_button_key: "Hủy",
      check_table_table: "Biểu mẫu",
      contractor_company: "Công ty nhà thầu",
      contractor_personnel_id: "ID nhân viên nhà thầu",
      corrective_action_title_key: "Biện pháp khắc phục",
      due_date_end: "Ngày đến hạn (đến)",
      due_date_start: "Ngày đến hạn (từ)",
      end_date: "Thời gian kết thúc",
      incident_category: "Loại tai nạn",
      incident_location: "Địa điểm xảy ra tai nạn",
      incident_location_range: "Phạm vi địa điểm",
      incident_organization: "Đơn vị có trách nhiệm",
      inspection_date_end: "Thời gian kiểm tra (đến)",
      inspection_date_start: "Thời gian kiểm tra (từ)",
      observer: "Người quan sát",
      occupation: "Nghề nghiệp / loại công việc",
      org_operation: "Vùng",
      report_date_key: "Ngày báo cáo",
      report_time: "Thời gian báo cáo",
      reset: "Đặt lại điều kiện",
      schedule_name: "Tên kế hoạch",
      area: "Khu vực",
      project: "Dự án",
      years: "Năm",
      report_start_time: "Thời gian bắt đầu",
      report_end_time: "Thời gian kết thúc",
      audit_type: "Loại kiểm toán",
      search_view_task_no_key: "Mã số nhiệm vụ:",
      select_upper_org_structure: "Trước tiên, bạn phải chọn một cơ cấu tổ chức cấp cao hơn",
      start_date: "Thời gian bắt đầu",
      task_type: "Loại kiểm tra",
      work_area: "Khu vực được quan sát",
      work_risk_level: "Mức độ rủi ro tại nơi làm việc",
      working_area: "Khu vực làm việc",
      select_current_executor: "Chọn người thực hiện hiện tại",
      select_final_verifier: "Chọn người xác minh cuối cùng",
      select_person_in_charge: "Chọn người phụ trách",
      select_reporter: "Chọn người báo cáo",
      select_reviewer: "Chọn người xem xét",
      select_verifier: "Chọn người xác minh",
      incident_schedule: "Tiến độ",
      task_name: "Tên nhiệm vụ",
      incident_subject: "Nội dung chính của vụ tai nạn",
      accident_number: "Mã số tai nạn",
      select_capa_source: "Chọn nguồn CAPA",
      search_capa_source: "Tìm kiếm nguồn CAPA",
      select_factory: "Chọn nhà máy",
      search_factory: "Tìm kiếm nhà máy",
      search_employee: "Tìm kiếm nhân viên"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "Chưa chọn khu vực",
      please_mark_one_point_on_floor_plan: "Vui lòng đánh dấu một điểm trên bản vẽ mặt bằng",
      reset_zoom: "Đặt lại thu phóng",
      selected_areas: "Khu vực đã chọn"
    },
    image_annotator_modal: {
      arrow: "↗ Mũi tên",
      cancel: "Hủy",
      circle: "○ Tròn",
      clear: "✕ Xóa",
      pen: "✏ Bút",
      pinch_zoom: "🤏 Chụm ngón tay để thu phóng",
      rect: "□ Khung",
      save: "Lưu chú thích",
      text_tool: "T Chữ",
      title_arrow: "Mũi tên",
      title_circle: "Hình tròn",
      title_pen: "Bút vẽ",
      title_rect: "Hình chữ nhật",
      title_reset_zoom: "Đặt lại thu phóng",
      title_text: "Văn bản",
      undo: "↩ Hoàn tác"
    },
    my_title: {
      homepage: "Trang chủ",
      enterprise_wechat_exit_home_alert: "Wechat doanh nghiệp thoát khỏi trang chủ "
    },
    no_source_img: {
      no_data: "Tạm không có dữ liệu"
    },
    org_select_modal: {
      choose_organization_structure: "Chọn cơ cấu tổ chức"
    },
    popover_dialog: {
      save_local: "Tạm thời lưu trữ trên điện thoại"
    },
    return_dialog: {
      close_case: "Đóng",
      invalid: "Không hiệu lực"
    },
    select_picture: {
      choose_from_media_msg: "Chọn từ album ảnh ",
      confirm_delete_msg: "Xác nhận xóa?",
      get_image_fail: "Nạp ảnh thất bại"
    },
    select_picture_new: {
      attachement_download_fail: "Tải xuống tệp đính kèm thất bại",
      be_uploading: "Đang tải lên",
      cancel_key: "Hủy",
      load_from_gallery: "Tải từ kho ảnh",
      select_image_source: "Chọn nguồn ảnh",
      use_camera: "Sử dụng máy ảnh",
      use_file: "Tải từ tệp",
      camera_access_denied: "Quyền truy cập máy ảnh bị từ chối. Vui lòng bật trong cài đặt hệ thống.",
      camera_not_found: "Không tìm thấy máy ảnh trên thiết bị."
    },
    spinner: {
      data_load_msg: "Dữ liệu đang tải, vui lòng đợi..."
    },
    svg: {
      top: "Đỉnh"
    },
    turn_to_send: {
      mission_assign_success: "Chuyển giao thành công",
      report_member: "Nhân viên tổ điều tra",
      select_mission_assignee_msg: "Hãy lựa chọn người giao nhiệm vụ",
      turn_to_send: "Chuyển giao",
      turn_to_send_to: "Chuyển giao nhiệm vụ cho",
      project_cost_center_code: "Mã trung tâm chi phí dự án"
    },
    select_file: {
      unsupported_format_desktop_only: "Định dạng tệp đính kèm này hiện chưa được hỗ trợ, vui lòng xem trên máy tính.",
      format_not_supported: "Định dạng tệp này hiện chưa được hỗ trợ để xem trực tuyến. Vui lòng sử dụng giao diện web để tải xuống và xem."
    },
    fabric_canvas: {
      please_select_first: "Không có đối tượng nào được chọn. Vui lòng chọn một đối tượng trước tiên.",
      delete_current_instance_only: "Xóa không thành công. Bạn chỉ có thể xóa bản vẽ liên quan đến vị trí này."
    }
  }
};
